/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_WarningInputs */

const en_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave this window open until syncing completes`)
};

const fr_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser cette fenetre ouverte jusqu'a la fin de la synchronisation`)
};

const de_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte lassen Sie dieses Fenster so lange geöffnet, bis die Synchronisierung abgeschlossen ist.`)
};

const it_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di lasciare aperta questa finestra fino al completamento della sincronizzazione`)
};

const ru_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, оставьте это окно открытым до завершения синхронизации.`)
};

const es_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deje esta ventana abierta hasta que se complete la sincronización.`)
};

const zh_cn2_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保持此窗口打开，直到同步完成。`)
};

const ja_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期が完了するまでこのウィンドウを開いたままにしてください`)
};

const hi_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया सिंक्रोनाइज़ेशन पूरा होने तक इस विंडो को खुला रखें।`)
};

const pt_pt2_sync_changes_warning = /** @type {(inputs: Sync_Changes_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, deixe esta janela aberta até que a sincronização seja concluída.`)
};

/**
* | output |
* | --- |
* | "Please leave this window open until syncing completes" |
*
* @param {Sync_Changes_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_warning = /** @type {((inputs?: Sync_Changes_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_warning(inputs)
	if (locale === "de") return de_sync_changes_warning(inputs)
	if (locale === "it") return it_sync_changes_warning(inputs)
	if (locale === "ru") return ru_sync_changes_warning(inputs)
	if (locale === "es") return es_sync_changes_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_warning(inputs)
	if (locale === "ja") return ja_sync_changes_warning(inputs)
	if (locale === "hi") return hi_sync_changes_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_warning(inputs)
	return en_sync_changes_warning(inputs)
});